import { Flex, Text } from '@chakra-ui/react';
import { CustomAlertTriangleIcon } from '../../../theme/icons/CustomAlertTriangleIcon';

interface CharLimitWarningProps {
  value: string;
  limit: number;
}

const CharLimitWarning = ({ value, limit }: CharLimitWarningProps) => {
  if (!value || value.length <= limit) return null;

  return (
    <Flex align="center" gap={1.5} mt={2} pl={0.5}>
      <CustomAlertTriangleIcon boxSize="13px" flexShrink={0} />
      <Text fontSize="12px" color="#666666">
        Long text values may get cut off on some devices
      </Text>
    </Flex>
  );
};

export default CharLimitWarning;
